import { attributes } from "@type-r/models";
import { useIO, useModel } from '@type-r/react';
import { div, getIdFromPath, Loading, Page, PageTab, TransparentTabs, useLinkedLocation } from "lqx-react";
import * as React from 'react';
import { Source } from "../api/source";
import { ResolvePaymentsPage } from "./payments";
import { SourcesList, SourceTile } from "./sources-list";

const State = attributes({
    sources: [ Source ]
})

export const ResolvePage = () => {
    const $category = useLinkedLocation(3, "payments"),
        category = $category.value;

    const state = useModel( State );

    const isReady = useIO( async () => {
        state.sources = [{
            id : 1,
            name : 'City',
            assetType : 'Payment',
            unresolvedAssets : 666
        },{
            id : 2,
            name : 'Bank',
            assetType : 'Payment',
            unresolvedAssets : 666
        }] as any;
    });

    return isReady ? 
        <Page
            top={
                <Background>
                    <TransparentTabs $value={$category}>
                        <PageTab
                        value="payments"
                        title="Payments"
                        label={'666'}
                        >
                            9 sources
                        </PageTab>
                    </TransparentTabs>
                </Background>
            }
        >
            <SourcesList>
                { state.sources.map( x => <SourceTile key={x.cid} source={ x }/> ) }
            </SourcesList>
        </Page>
    :
        <Loading/>
};

const Background = div({
    backgroundColor : '#052C4C'
});

export const ResolvePageRouter = () => {
    const sourceId = getIdFromPath( 3 );

    return sourceId !== undefined ? 
        <ResolvePaymentsPage sourceId={ sourceId }/> :
        <ResolvePage />
}